import React from 'react'

const Star = props => (
  // <svg
  //   width='14'
  //   height='13'
  //   viewBox='0 0 14 13'
  //   fill={props ? props.color : '#97A3C7'}
  //   className={props.className ? props.className : ''}
  //   xmlns='http://www.w3.org/2000/svg'
  // >
  //   <path
  //     fillRule='evenodd'
  //     clipRule='evenodd'
  //     d='M6.61038 11.3609L3.58069 12.9065C3.17145 13.1153 2.66529 12.9626 2.45014 12.5655C2.36447 12.4074 2.3349 12.2262 2.36603 12.0502L2.94464 8.77652C2.99122 8.513 2.90119 8.24412 2.70388 8.05749L0.252811 5.73909C-0.0782695 5.42593 -0.085044 4.91162 0.23768 4.59035C0.36619 4.46242 0.534577 4.37916 0.716773 4.35347L4.10407 3.87585C4.37674 3.83741 4.61245 3.67123 4.73439 3.43147L6.24924 0.453011C6.45386 0.0506933 6.95584 -0.114488 7.37044 0.0840672C7.53554 0.163133 7.66917 0.292806 7.75065 0.453011L9.2655 3.43147C9.38744 3.67123 9.62315 3.83741 9.89582 3.87585L13.2831 4.35347C13.7407 4.41799 14.0577 4.83021 13.9912 5.27419C13.9647 5.45099 13.8789 5.61438 13.7471 5.73909L11.296 8.05749C11.0987 8.24412 11.0087 8.513 11.0552 8.77652L11.6339 12.0502C11.712 12.4924 11.406 12.9123 10.9503 12.9881C10.7688 13.0183 10.5822 12.9897 10.4192 12.9065L7.38951 11.3609C7.14562 11.2365 6.85427 11.2365 6.61038 11.3609Z'
  //   />
  // </svg>
  <svg
    width='20'
    height='21'
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={props.className ? props.className : ''}
  >
    <path
      d='M15.5588 20.0002C15.3989 20.0008 15.2411 19.9631 15.0988 19.8902L9.99879 17.2202L4.89879 19.8902C4.73318 19.9773 4.54646 20.0162 4.35986 20.0024C4.17326 19.9887 3.99426 19.9228 3.84321 19.8124C3.69217 19.702 3.57513 19.5514 3.5054 19.3778C3.43567 19.2041 3.41606 19.0144 3.44879 18.8302L4.44879 13.2002L0.328786 9.2002C0.200244 9.07193 0.109058 8.91107 0.0650138 8.7349C0.0209699 8.55872 0.025731 8.37388 0.078786 8.2002C0.136746 8.02248 0.243362 7.86456 0.386536 7.74436C0.52971 7.62417 0.703709 7.54651 0.888786 7.5202L6.58879 6.6902L9.09879 1.5602C9.18067 1.39113 9.30852 1.24855 9.4677 1.14878C9.62687 1.04901 9.81093 0.996094 9.99879 0.996094C10.1866 0.996094 10.3707 1.04901 10.5299 1.14878C10.689 1.24855 10.8169 1.39113 10.8988 1.5602L13.4388 6.6802L19.1388 7.5102C19.3239 7.53651 19.4979 7.61417 19.641 7.73436C19.7842 7.85456 19.8908 8.01248 19.9488 8.1902C20.0018 8.36388 20.0066 8.54872 19.9626 8.7249C19.9185 8.90107 19.8273 9.06193 19.6988 9.1902L15.5788 13.1902L16.5788 18.8202C16.6145 19.0077 16.5958 19.2015 16.5249 19.3787C16.454 19.5559 16.3339 19.7091 16.1788 19.8202C15.9977 19.9471 15.7797 20.0104 15.5588 20.0002Z'
      fill={props ? props.color : '#97A3C7'}
      className={props.className ? props.className : ''}
    />
  </svg>
)

export default Star
